<template>
	<div class="s-gray-bg p-user-select" style="overflow:scroll;width:100%; ">
		<div v-show="sportReportLocationDots&&sportReportLocationDots.length>0" id="container" class="map-container" style="width:100%;height:20rem;"></div>
		<!-- <div style="width:100%;" class="p-margin-top20">
			<img src="../assets/img/head_defualt.png"  style="width:100%;">
		</div> -->
		<div style="width:100%;" class="p-white-bg p-padding-top10 p-radius40">
			<div class="p-margin20 p-margin-top20 p-font0-8 p-color3 ">
				{{formatDateStringByMillSecond(sportReportDetailData.sts,$t('common.formatDateYMDHMS'))}}
			</div>
			<div class="p-margin20 p-margin-top20 p-font1-2 p-black">
				{{$t('sport.sportStatistics')}}
			</div>
			<div class="p-margin-top20  p-space-between p-box-center-x p-font4 p-black">
				{{sportReportDetailData.sportskm}}
			</div>
			<div class="p-space-between p-box-center-x p-font0-6 p-color3">
				{{$t('sport.distanceAndUnit')}}
			</div>

			<div  class="p-margin-top20 p-margin20 p-font1-0 p-space-between " >
				<span style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{sportReportDetailData.avgPace}}
				</span> 
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{sportReportDetailData.avgCadence}}
				</span> 
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{sportReportDetailData.consume}}kcal
				</span> 
			</div>
			<div  class="p-margin-top5  p-margin20 p-space-between p-box-center-y p-font0-6 p-color3" >
				<span style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{$t('sport.pacingAvg')}}
				</span>
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{$t('sport.cadenceAvg')}}
				</span> 
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{$t('sport.consumeAvg')}}
				</span> 
			</div>

			<div  class="p-margin-top20 p-margin20 p-font1-0 p-space-between " >
				<span style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{getHourBySecondStr(sportReportDetailData.ts)=='00'?(''):(getHourBySecondStr(sportReportDetailData.ts)+':')}}{{getMinBySecondStr(sportReportDetailData.ts)}}:{{getSecondBySecondStr(sportReportDetailData.ts)}}
				</span> 
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{sportReportDetailData.totalStepNumber}}
				</span> 
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
				{{sportReportDetailData.avghr}}
				</span> 
			</div>
			<div  class="p-margin-top5 p-margin20 p-space-between p-box-center-y p-font0-6 p-color3" >
				<span style="padding-top: 0.1rem;width:33%;text-align:center;">
					{{$t('sport.timeNum')}}
				</span>
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
					{{$t('sport.totalStepNum')}}
				</span> 
				<span  style="padding-top: 0.1rem;width:33%;text-align:center;">
					{{$t('measure.heartRateAvg')}}
				</span> 
			</div>

			<div  class="p-margin20 p-margin-top40 p-box-center-y p-font1-2 p-black"  >
				<span>
					{{$t('measure.heartRate')}}
				</span>
				<span style="padding-top: 0.4rem;" class="p-margin-left30   p-font0-8">
				{{$t('common.average')}}{{sportReportDetailData.avghr}}{{$t('common.numMinUnit')}}
				</span> 
				<span  style="padding-top: 0.4rem;" class="p-margin-left30 p-font0-8">
					{{$t('common.highest')}}{{sportReportDetailData.maxhr}}{{$t('common.numMinUnit')}}
				</span> 
			</div>
			<div v-if="HRSportCanvasOnoff" class="p-box-center p-margin-top20"
					:style="`height:${  canvasHeight+parseInt(canvasPadding[2])  }px;`">
						<brokenLine
								ref="SportHrBrokenLine"
								v-if="HRSportCanvasOnoff"
							  	:new-time.sync="sportReportDetailData.newTime"
								:type="'waveLineNoDrag'"
								:width="canvasWidth"
								:height="canvasHeight"
								:padding="canvasPadding"
								:xAxisStrs="sportReportDetailData.xzhou"
								:x-axis="(24)"
								:y-axis="[0,50,100,150,200]"
								:dots="sportReportDetailData.hrChartDots"
								:axios-color="colorArr[3]"
								:btn-color="colorArr[1]"
								:color-arr="[colorArr[5],'#FFFFFF',colorArr[7]]"
								:line-width="canvasLineWidth/3"
								 @sendData="sendDataSportHR">
							<template  v-slot:default>
								{{  returnDataSportHR.y | yAxisCompute2(0,200,canvasHeight)  }}
							</template>
						</brokenLine>

			</div>
			<div  style="height:2rem;"></div>
		</div>
	</div>
</template>

<script>
	import toggleTime from "../components/toggleTime.vue";
	import pillarNibpReport from "../components/chart/pillarNibpReport.vue";
	import brokenLine from '../components/chart/brokenLine.vue'
    import pie from '../components/chart/pie.vue'
	import mixins from '@/utils/mixins.js'
	import {
		jsonToParams,
		getKCalorie,
		getCalorie,
		getHourBySecond,
		getMinBySecond,
		getSecondBySecond,
		getHourBySecondStr,
		getMinBySecondStr,
		getSecondBySecondStr,
		formatDateStringByMillSecond,
	} from '@/utils/methods.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			toggleTime,
            pie,
            brokenLine,
		},
	data() {
		return {
			pid: 0,
			vtoken: '',
		}
	},
		methods: {
			getKCalorie,
			getCalorie,
			getHourBySecond,
			getMinBySecond,
			getSecondBySecond,
			getHourBySecondStr,
			getMinBySecondStr,
			getSecondBySecondStr,
			formatDateStringByMillSecond,
			goToSettingSportMaxHr(){
				if(this.sportReportDetailData){
					this.$router.push({
						path: '/sportReportMaxHrSetting',
						query: {
						pid: this.$route.query.pid,
						sportData: this.sportReportDetailData,
						language:this.$route.query.language
						}
					})	
				}
			},
			updateLocationUI(){
				var path = []
				let maxLat=0;
				let minLat=0;
				let maxLon=0;
				let minLon=0;

				// 折线的节点坐标数组，每个元素为 AMap.LngLat 对象      先计算出中心点在哪里
				for(let i=0;i<this.sportReportLocationDots.length;i++){
					if(maxLat<this.sportReportLocationDots[i].latitude){
						maxLat=this.sportReportLocationDots[i].latitude;
					}
					if(0==minLat||minLat>this.sportReportLocationDots[i].latitude){
						minLat=this.sportReportLocationDots[i].latitude;
					}
					if(maxLon<this.sportReportLocationDots[i].longitude){
						maxLon=this.sportReportLocationDots[i].longitude;	
					}
					if(0==minLon||minLon>this.sportReportLocationDots[i].longitude){
						minLon=this.sportReportLocationDots[i].longitude;
					}
					path.push(new AMap.LngLat(this.sportReportLocationDots[i].latitude,this.sportReportLocationDots[i].longitude))
				}
				var tmpZoom=15;
				if(maxLat-minLat>0.33){
					tmpZoom=11;
				}else if(maxLat-minLat>0.15){
					tmpZoom=12;
				}else if(maxLat-minLat>0.09){
					tmpZoom=13;
				}else if(maxLat-minLat>0.05){
						tmpZoom=14;
				}
				// var path = [
				// 	new AMap.LngLat(116.368904,39.913423),
				// 	new AMap.LngLat(116.382122,39.901176),
				// 	new AMap.LngLat(116.387271,39.912501),
				// 	new AMap.LngLat(116.398258,39.904600)
				// ];
		
				// 地图初始化应该在地图容器div已经添加到DOM树之后
				var map = new AMap.Map('container', {
					zoom:tmpZoom,
					center: [(maxLat+minLat)/2,(maxLon+minLon)/2],//中心点坐标
					viewMode:'2D'//使用2D视图
				})

				

				var polyline = new AMap.Polyline({
					path: path,  
					borderWeight: 1, // 线条宽度，默认为 1
					strokeColor: 'blue', // 线条颜色
					lineJoin: 'round' // 折线拐点连接处样式
				});

				map.add(polyline);
				AMap.plugin([
					'AMap.ToolBar',
					// 'AMap.Scale',
					// 'AMap.HawkEye',
					// 'AMap.MapType',
					// 'AMap.Geolocation',
				], function(){
					// 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
					map.addControl(new AMap.ToolBar());

					// 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
					// map.addControl(new AMap.Scale());

					// // 在图面添加鹰眼控件，在地图右下角显示地图的缩略图
					// map.addControl(new AMap.HawkEye({isOpen:true}));
				
					// // 在图面添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
					// map.addControl(new AMap.MapType());
				
					// // 在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
					// map.addControl(new AMap.Geolocation());
				});
			},
			getData(){
				this.getSportDetail(this.$route.query.sportId,this.updateLocationUI);
			},
		},
		created() {
			document.title = this.$t('sport.sportReport');
			
		},
		mounted(){
			this.getData();
		}

	}
</script>
<style scoped>

</style>
